module.exports = __webpack_public_path__ + "media/images/icon/mail-ae7948aac39e2dc5950b363bfa5244d7.png";